import React from "react";
import styles from "../styles/AuthFooter.module.css";
import moment from "moment";
import { Constants } from "../utils/Constants";

export default function AuthFooter({ style = {} }) {
    return (
        <footer className={styles.footer} style={style}>
            <div className={styles.containerFooter}>
                <a className="tt-16 main-color-05" href={"/termos-de-uso"} target="_blank" rel="noopener noreferrer">
                    Políticas de Privacidade
                </a>

                <a className="tt-16 main-color-05" href={"/termos-de-uso"} target="_blank" rel="noopener noreferrer">
                    Termos de Uso
                </a>
            </div>

            <div className="d-flex align-items-center gap-4">
                <a className="tt-16 color-gray-07 " target="_blank" rel="noopener noreferrer">
                    © {moment().format("YYYY")} Lumi.
                </a>
            </div>
        </footer>
    );
}
